import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import esTranslations from './locales/es.json';
import itTranslations from './locales/it.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: esTranslations
      },
      it: {
        translation: itTranslations
      }
    },
    supportedLngs: ['es', 'it'],
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

function updateDocumentLocale(lng: string) {
  const base = (lng && lng.split('-')[0]) || 'es';
  const locale = base === 'es' ? 'es-ES' : base === 'it' ? 'it-IT' : base;
  if (typeof document !== 'undefined' && document.documentElement) {
    const html = document.documentElement;
    html.lang = locale;
    html.setAttribute('translate', 'no');
    html.classList.add('notranslate');
    if (document.body) {
      document.body.setAttribute('translate', 'no');
      document.body.classList.add('notranslate');
    }
  }
}

const initialLng = i18n.language || i18n.resolvedLanguage || 'es';
updateDocumentLocale(initialLng);
i18n.on('languageChanged', updateDocumentLocale);

export default i18n; 
